export function getCsrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  if (!meta) throw new Error('CSRF token meta tag not found');
  return meta.content;
}
